const places= [
    {
        id: 1,
        name : "Cox's Bazar",
        description : "Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very lng, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
        image : "https://i.ibb.co/dPcnB5D/cox-s-bazaar-syed-zakir-hossain-1584366863439.jpg",
        lat:21.433920,
        lng:91.987030
    },
    {
      id:2,
      name : "Sreemangal",
      description  : "Sreemangal is situated in Moulvibazar district in sylhet division. Sreemangal is an Upazila. It is famous for tea garden. Rain all time occurs here. Nature has adorned sreemangal with green tress. Its natural scenery is very charming. It soothes one’s eyes. Birds are twittering always here. The first tea garden in Bangladesh which names “Malni chho ra tea garden” is here. Only one tea research institute in Bangladesh which name is BTRI (Bangladesh Tea Research Institute) is situated in Sreemangal",
      image :"https://i.ibb.co/FK5Yttd/Sreemangal-Bangladesh-bangladesh-41724984-500-383.jpg",
      lat:24.3105781,
      lng:91.725133
  },
  {
      id:3,
      name : "Sundarbans",
      description  : "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh.",
      image :"https://i.ibb.co/kcJJrZv/800px-Beauty-of-Sundarban-river02.jpg",
      lat:21.9704426,
      lng:89.78811589676832
  
  },
  
  
  ]
  export default places;